import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Fieldset, type SwitchProps, Theme } from "tamagui";
import { Switch } from "../Switch";
import { Label } from "../Typography";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
export const BooleanSwitchField = (props: Pick<SwitchProps, "size" | "native">) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<boolean>();
  const {
    label,
    isOptional
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const id = useId();
  const inputId = `${id}_boolean_switch_input`;
  const disabled = isSubmitting;
  return <Theme name={error ? "red_alt2" : "granted"} forceClassName data-sentry-element="Theme" data-sentry-component="BooleanSwitchField" data-sentry-source-file="BooleanSwitchField.tsx">
      <Fieldset ai="flex-start" data-sentry-element="Fieldset" data-sentry-source-file="BooleanSwitchField.tsx">
        {label ? <Label htmlFor={inputId} size={props.size || "$3"} pb="$1" pl={0}>
            {label}
            {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
          </Label> : null}
        <Switch disabled={disabled} checked={field.value} onCheckedChange={checked => field.onChange(checked)} ref={field.ref} id={inputId} key={inputId} size="$3.5" {...props} data-sentry-element="Switch" data-sentry-source-file="BooleanSwitchField.tsx">
          <Switch.Thumb data-sentry-element="Switch.Thumb" data-sentry-source-file="BooleanSwitchField.tsx" />
        </Switch>
        <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="BooleanSwitchField.tsx" />
      </Fieldset>
    </Theme>;
};